<template>
  <InnerView>
    <template #header>
      <div class="space-y-2">
        <h1
          class="flex items-center font-bold text-primary-contrast pl-1 tracking-wide transition-all text-3xl"
        >
          {{ $t('feedbacks.title') }}
        </h1>
        <feedback-menu-view :focusNewTab="focusNewTab" />
      </div>
    </template>
    <feedback-view
      class="h-full"
      :collectionPath="focusContent.path"
      :contentParents="focusContent.contentParents"
      :mainContent="focusContent.content"
      :report-recipients="reportRecipients"
      :source="source"
      :lang="selectedLanguage"
      @select-item="showEntity"
      @refresh-roles="refreshRoles"
    />
  </InnerView>
</template>

<script setup lang="ts">
import { useAdminStore, useKnowledgeStore, useFeedbackStore } from '@getmayday/vue-modules'
import { useRoute } from 'vue-router'
import useEntities from '@commons/composables/useEntities'
import InnerView from '@commons/components/Layout/InnerView.vue'

const adminStore = useAdminStore()
const { reportRecipients, userId } = storeToRefs(adminStore)

const knowledgeStore = useKnowledgeStore()
const {
  content,
  contentParents,
  path,
  modalContent,
  modalContentParents,
  modalPath,
  selectedLanguage
} = storeToRefs(knowledgeStore)

const feedbackStore = useFeedbackStore()

const { showEntity } = useEntities()

const route = useRoute()

const focusNewTab = computed(() => route.query.new === '1')
const focusContent = computed(() =>
  !!route.query.modalContentId && route.query.modalContentId !== '-1'
    ? {
        content: modalContent.value,
        contentParents: modalContentParents.value,
        path: modalPath.value
      }
    : {
        content: content.value,
        contentParents: contentParents.value,
        path: path.value
      }
)

let source = ''
onMounted(() => {
  source = route.query.source as string
  feedbackStore.setAuthorId(userId.value as string)
})

const refreshRoles = () => {
  adminStore.refreshRoles()
}
</script>
